import { CARGO_TYPE } from '../../cargoType';
import useAgent from '../../hooks/useAgent';
import { getTransactionsOptions } from '../hooks/useGetTransactionsOptions';

const useGetBulkTransactionsOptions = () => useAgent(() => getTransactionsOptions({ cargoType: CARGO_TYPE.bulk }));

export default useGetBulkTransactionsOptions;
